module.exports = __webpack_public_path__ + "img/icon8.a0ab8277.png";